<template>
  <div id="task-raiting">
    <avatar-interface :src="avatarDriver" :size="size" :border-radius="borderRadius" :background-color="backgroundColor" class="mr-20" />
    <div class="tr-raiting">
      <el-rate v-model="rating" class="mt-10 float-right" disabled-void-icon-class="el-icon-star-off" :disabled="disabled" />
    </div>
  </div>
</template>
<script>
import AvatarInterface from '@/components/AvatarInterface'
import CONSTANTS from '@/utils/const'

export default {
  name: 'TaskRaiting',
  components: {
    AvatarInterface
  },
  props: {
    src: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: () => '50px'
    },
    rateValue: {
      type: Number,
      required: true
    },
    rateField: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    borderRadius: {
      type: String,
      default: () => '100%'
    },
    backgroundColor: {
      type: String,
      default: () => 'rgba(23, 11, 86, 0.2)'
    }
  },
  computed: {
    rating: {
      get: function() {
        return this.rateValue
      },
      set: function(value) {
        this.$emit('update:rateValue', value)
      }
    },
    avatarDriver: function() {
      return this.src ? this.src : CONSTANTS.AVATAR.DRIVER
    }
  }
}
</script>
<style>

.tr-rate {
  float: right;
}

#task-raiting {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  padding: 10px 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 44px;
  border: 1px solid #d8d8d8;
}

#task-raiting #avatar-interface {
  margin: 0 !important;
}

#task-raiting #avatar-interface .ai-decoration {
  width: 60px !important;
  height: 60px !important;
}

#task-raiting #text-field-detail {
  max-width: 200% !important;
  width: 100% !important;
  text-align: center !important;
  margin-top: 10px;
}

.tr-raiting {
  width: calc(100% - 60px);
}
</style>
